import styled, { css } from 'styled-components';

export const Content = styled.div``;

export const Middle = styled.div`
  width: 20px;
  height: 20px;
  background: #aaa;
  margin: 0 0.5rem 0 0;
  /* v2: a proper "partial" checkbox (light-green + white dash) instead of a
     flat grey square. */
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      width: 18px;
      height: 18px;
      border-radius: 5px;
      background-color: #7ad17a;
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='%23fff' stroke-width='2.2' stroke-linecap='round' d='M4 8h8'/></svg>");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    `}
`;

export const Name = styled.div`
  margin: 0 0 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* padding: 5px; */
  /* border: 1px solid #ccc; */
  /* border-radius: 5px; */
  input {
    width: 20px;
    height: 20px;
    accent-color: var(--cp-accent, #aaa);
  }
`;

export const Items = styled.div`
  input {
    cursor: pointer;
    margin: 0 0.5rem 0 0;
  }
  label {
    cursor: pointer;
    display: flex;
    font-weight: normal;
    align-items: center;
    margin: 0 0 5px;
    flex-grow: 0;
    input {
      width: 20px;
      height: 20px;
    }
    ::first-letter {
      text-transform: capitalize;
    }
  }

  &.sub {
    padding: 3px 0 4px 27px;
  }
`;
